//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HomeGameWheelInformation from './HomeGameWheelInformation.vue';
import { CELLS } from './cells';
import { getNumberFromAngle, bezierEasing } from '../helpers';
import { GameStatus, WHEEL_SPINNER } from '../wheel.entity';

const SPIN_DURATION = 7000;
const BEZIER_FN = [0.32, 0.64, 0.45, 1];

export default {
  name: 'WheelHomeGameWheel',
  components: {
    HomeGameWheelInformation
  },
  props: {
    game: {
      type: Object,
      default: null
    },
    playSound: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      CELLS,
      GameStatus,
      animationEnded: false,
      spinnerSvgTransform: null,
      winCell: null,
      prevStatus: undefined,
      activeAnimation: null,
      animFrameId: null,
      currentAngle: 0,
      targetAngle: 0
    };
  },
  computed: {
    // 强制声明 transformOrigin，修复移动端转盘旋转偏心问题
    svgStyle() {
      return this.spinnerSvgTransform
        ? { transform: this.spinnerSvgTransform, transformOrigin: '50% 50%' }
        : { transformOrigin: '50% 50%' };
    }
  },
  watch: {
    game: {
      immediate: true,
      deep: true,
      handler(newGame) {
        if (!newGame) return;

        if (this.prevStatus !== newGame.status) {
          this.prevStatus = newGame.status;
          this.stopSpinnerAnimation();
          this.onStatusChanged();
        }
      }
    }
  },
  beforeDestroy() {
    this.stopSpinnerAnimation();
  },
  methods: {
    onStatusChanged() {
      if (!this.game) return;

      const { status, winNumber } = this.game;

      if (status === GameStatus.STARTED) {
        this.winCell = winNumber;
        this.animationEnded = false;

        this.calculateTargetAngle(winNumber);

        this.$nextTick(() => {
          this.startSpin();
        });
      } else if (status === GameStatus.CREATED) {
        this.winCell = null;
        this.animationEnded = false;
        this.setSpinnerTransform(this.currentAngle);
      } else if (status === GameStatus.ENDED) {
        this.winCell = winNumber;

        if (this.currentAngle === 0) {
          this.calculateTargetAngle(winNumber);
          this.currentAngle = this.targetAngle;
        }

        this.setSpinnerTransform(this.currentAngle);
      }
    },

    calculateTargetAngle(winIndex) {
      if (winIndex === undefined || winIndex === null) return;
      const totalSections = WHEEL_SPINNER.length;
      const sectionAngle = 360 / totalSections;

      const sectorCenterAngle = (winIndex * sectionAngle) + (sectionAngle / 2);
      const stopBaseAngle = (360 - sectorCenterAngle) % 360;

      const currentFullRotations = Math.floor(this.currentAngle / 360) * 360;

      let nextTarget = currentFullRotations + stopBaseAngle;
      if (nextTarget <= this.currentAngle) {
        nextTarget += 360;
      }

      this.targetAngle = nextTarget + (360 * 5);
    },

    startSpin() {
      if (this.activeAnimation || !this.$refs.wheel) {
        return;
      }

      const bezierString = `cubic-bezier(${BEZIER_FN.join(',')})`;
      const el = this.$refs.wheel;

      this.spinnerSvgTransform = null;

      if (el.animate) {
        const animation = el.animate(
          [
            { transform: `rotate(${this.currentAngle}deg)`, transformOrigin: '50% 50%' },
            { transform: `rotate(${this.targetAngle}deg)`, transformOrigin: '50% 50%' }
          ],
          {
            duration: SPIN_DURATION,
            easing: bezierString,
            fill: 'forwards'
          }
        );

        this.activeAnimation = animation;

        this.startTickSound(this.currentAngle, this.targetAngle);

        animation.onfinish = () => {
          this.stopTickSound();
          this.activeAnimation = null;
          this.animationEnded = true;

          this.currentAngle = this.targetAngle;
          this.setSpinnerTransform(this.currentAngle);
        };
      }
    },

    startTickSound(startAngle, targetAngle) {
      const colorsCount = WHEEL_SPINNER.length;
      const timingFn = bezierEasing(BEZIER_FN[0], BEZIER_FN[1], BEZIER_FN[2], BEZIER_FN[3]);
      const startTime = performance.now();
      const totalAngleChange = targetAngle - startAngle;

      let lastNumberId = null;

      const tick = () => {
        const elapsed = performance.now() - startTime;
        if (elapsed >= SPIN_DURATION) {
          return;
        }

        const pos = elapsed / SPIN_DURATION;
        const currentAngle = startAngle + timingFn(pos) * totalAngleChange;
        const numberId = getNumberFromAngle(currentAngle, colorsCount);

        if (numberId !== lastNumberId) {
          lastNumberId = numberId;
          if (typeof this.playSound === 'function') {
            this.playSound('wheel-spinner-click');
          }
        }

        this.animFrameId = requestAnimationFrame(tick);
      };

      this.animFrameId = requestAnimationFrame(tick);
    },

    stopSpinnerAnimation() {
      if (this.activeAnimation) {
        this.activeAnimation.cancel();
        this.activeAnimation = null;
      }
      this.stopTickSound();
    },

    stopTickSound() {
      if (this.animFrameId) {
        cancelAnimationFrame(this.animFrameId);
        this.animFrameId = null;
      }
    },

    setWinNumber(winColor, winNumber) {
      this.winCell = winNumber;
    },

    setSpinnerTransform(angle) {
      this.spinnerSvgTransform = `rotate(${angle}deg)`;
    }
  }
};
